module.exports = __webpack_public_path__ + "static/img/3.df4f978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = ZK0V
// module chunks = 1